import { IProductDataV3 } from '@df/catalog/product/product';
import { NProductViewLayout, Product } from '../product.decorator';
export namespace NProductViewUpsellProducts {
    export const GROUP_BY_ATTRIBUTE_CODE = 'nyw_item_category_desc_nh_bs';
    export const MODAL_ID = 'product-view-upsell-products-modal';
    export interface IModalData {
        groups: IUpsellGroup[];
        onConfirm: (data: OnConfirmData) => void;
        selection: number[];
        label: string;
        content: NProductViewLayout.IBlockDataContent;
    }
    export interface IUpsellGroup {
        id: string;
        label: string | undefined;
        products: Product<IProductDataV3>[];
    }

    export interface OnConfirmData {
        selection: number[];
        /**
         * Key is old product id, value is new product id
         * We need ths to replace upsell items in source data, so if we reopen modal, we have previously selected products there.
         * I know it is not a perfect solution but i really dont see any reasonable alternatives reasonable considering the time needed.
         */
        replacements?: { [key: string]: number };
    }
}
